import { gql } from '@apollo/client'

export const FILES_IN_PROCESSING_QUERY = gql`
  query filesInProcessingQuery($processingId: ID!) {
    uploads(processingId: $processingId) {
      collection {
        id
        attachmentUrl
        attachmentFilename
      }
    }
  }
`
